<div class="array-tooltip-display-wrap">
    <ng-container><span class="first-item" [class.has-tip]="getItems().length > 1">{{getItems()[0] | display}}</span></ng-container>
    <ng-container *ngIf="getItems().length > 1">
        <span (click)="$event.preventDefault();$event.stopPropagation();" class="amount" placement="bottom" [autoClose]="false" tabindex="0" triggers="hover focus" [ngbTooltip]="getTip()" [openDelay]="100" [closeDelay]="200">+{{getItems().length - 1}}</span>
    </ng-container>
</div>